<template>

    <q-input outlined dense
             label="Install ID" stack-label
             autocomplete="on" name="installationId"
             v-model.trim="installationId"
             ref="installIdRef"
             :loading="isInstallIdValidPending"
             :error-message="isValidIdErrorMessage"
             :error="!isValidId"
             @change="checkInstallIdValid()"
             class="col-xs-12 col-md-6"
             :rules="[ val => $v.installationId.required || 'Install ID is required' ]"
             :readonly="readonly"
             hide-bottom-space>
        <template v-slot:append>
            <q-icon v-if="showCheck && !readonly" name="mdi-check-bold" color="positive" />
        </template>
    </q-input>
</template>
<script>
    import { mapState } from 'vuex'
    import { requiredIf } from 'vuelidate/lib/validators'

    export default {
        name: 'validate-install-id',
        props: {
            formInstallId: String,
            productCategoryId: {
                default: '',
                type: String,
            },
            required: {
                default: false,
                type: Boolean
            },
            readonly: {
                default: false,
                type: Boolean
            },
        },
        data() {
            return {
                showCheck: false,
                installationId: '',
                isValidId: true,
                isValidIdErrorMessage: '',
            }
        },
        validations: {
            installationId: { required: requiredIf(function () { return this.required }) },
        },
        methods: {
            validate() {
                if (this.$refs.installIdRef && typeof this.$refs.installIdRef.validate === 'function') {
                    this.$refs.installIdRef.validate()
                }
            },
            //hasError() {
            //    this.$emit('updateCodeValidity', !this.$refs.installIdRef.hasError())
            //},
            clearError() {
                this.showCheck = false
                this.isValidId = true
                this.isValidIdErrorMessage = ''
            },
            checkInstallIdValid() {
                this.$emit('updateInstallId', this.installationId)
                this.clearError()
                if (this.installationId) {
                    this.$store.dispatch('validateInstallId', { productCategoryId: this.productCategoryId, installId: this.installationId }).then(() => {
                        if (typeof this.isInstallIdValidData !== 'undefined') {
                            this.isValidId = this.isInstallIdValidData
                            if (!this.isValidId) {
                                this.isValidIdErrorMessage = 'Install ID is invalid'
                                this.$emit('updateInstallId', '')
                            }
                            else {
                                this.$emit('updateInstallId', this.installationId)
                                this.showCheck = true
                            }

                        }
                    })
                }
            },
        },
        computed: {
            ...mapState([
                'isInstallIdValidPending',
                'isInstallIdValidData',
            ]),
        },
        created() {
            if (this.formInstallId) {
                this.installationId = this.formInstallId
                this.checkInstallIdValid()
            }

        },
    }
</script>
